module.exports = __webpack_public_path__ + "img/couples-026.facd51aa.jpg";